// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export const appVersion = () => import.meta.env.VITE_ENV_APP_VERSION ?? 'NaN';
